import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const CTABanner = ({ onQuoteClick }) => {
  const { t } = useLang();
  return (
    <section
      id="contact"
      data-testid="cta-banner"
      className="relative py-16 sm:py-24 lg:py-32 bg-[#09090b] overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(14,165,233,0.15)_0%,_transparent_60%)]"></div>
      <div className="relative mx-auto max-w-5xl px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-3 mb-8">
          <span className="h-px w-12 bg-sky-400"></span>
          <span className="eyebrow">{t.cta.eyebrow}</span>
          <span className="h-px w-12 bg-sky-400"></span>
        </div>
        <h2
          data-testid="cta-title"
          className="font-display font-black text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tighter mb-6"
        >
          {t.cta.title}
        </h2>
        <p className="text-zinc-400 text-lg max-w-2xl mx-auto mb-12">
          {t.cta.subtitle}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            data-testid="cta-call-button"
            href="tel:+15105079318"
            className="btn-primary"
          >
            <Phone size={16} />
            {t.cta.call} · (510) 507-9318
          </a>
          <button
            data-testid="cta-quote-button"
            onClick={onQuoteClick}
            className="btn-secondary"
          >
            {t.cta.quote}
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
